export default "./images/survio-3DHSt-assets-stripe.svg";